import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { CompanySegment } from 'src/app/models/CompanySegment';
@Injectable({
    providedIn: 'root'
})
export class CompanySegmentApi extends Api<CompanySegment> {
}
